import { render, staticRenderFns } from "./Fiscalizacoes.vue?vue&type=template&id=75bf7d36&"
import script from "./Fiscalizacoes.vue?vue&type=script&lang=js&"
export * from "./Fiscalizacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports